import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IResendSlackPayload, IResendSlackInput } from './types'
import handleFetchResult from '@utils/handleFetchResult'

const mutateHandler = handleFetchResult<IResendSlackPayload, boolean>({
  handler: (data) => data.createSlackNotification.status,
  name: 'Slack',
})

export default function resend(input: IResendSlackInput): Promise<boolean> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation SendSlackInstructions($input: CreateSlackNotificationMutationInput!) {
    createSlackNotification(input: $input) {
      status
    }
  }
`
